const UPDATE_FOUND = '업데이트가 발견되어 새로운 버전을 설치합니다.';
const LAST_SEEN_KEY = 'kurlyro:lastSeenBuildVersion';

/**
 * 모든 환경(dev/stg/qa/prod)에서 동작하는 빌드 버전 체크.
 * - 초기 진입(앱 최초 실행, 종료 후 재실행, 웹 새로고침) 시 한 번 호출.
 * - 빌드 시 webpack DefinePlugin이 inject한 process.env.BUILD_VERSION 과
 *   localStorage에 저장된 "마지막으로 본 버전"을 비교한다.
 * - 다르면 alert. 새 번들은 이미 로드된 상태이므로 사용자가 OK 누르면 그대로 사용.
 * - 첫 진입(lastSeen=null)에는 알럿을 띄우지 않고 현재 버전만 기록한다.
 */
export const checkBuildVersion = (): void => {
  const builtVersion = process.env.BUILD_VERSION;
  if (!builtVersion) return;

  const lastSeen = localStorage.getItem(LAST_SEEN_KEY);
  localStorage.setItem(LAST_SEEN_KEY, builtVersion);

  if (lastSeen !== null && lastSeen !== builtVersion) {
    alert(UPDATE_FOUND);
  }
};
